import { Component, Input, OnInit } from '@angular/core';
import { ScorecardView } from '../../models/views';
import { NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-score-card',
    templateUrl: './score-card.component.html',
    styleUrls: ['./score-card.component.scss'],
    standalone: true,
    imports: [MatTooltip, NgClass]
})

export class ScoreCardComponent implements OnInit {
  @Input() scorecard: ScorecardView;
  specialMessage: string | null = null;
  isVacant: boolean = false;
  score: number;
  scoreClass: string;
  constructor() { }

  ngOnInit() {
    this.checkForSpecialCases();
    this.isVacant = this.scorecard.votingHistory && this.scorecard.votingHistory.length > 0;
    this.updateScore();
  }

  getVoteClass(vote: string): string {
    if (vote.toLowerCase().includes('against') || vote.toLowerCase().includes('absent'))
      return 'against';
    else if (vote.toLowerCase().includes('with'))
      return 'with';
    else
      return 'no-vote';
  }

  onImageError = (event: any) => event.target.src = 'assets/default-headshot.png';
  
  checkForSpecialCases(): void {
    if (!this.scorecard?.votingHistory?.length) return;
    const hasAbsent = this.scorecard.votingHistory.some(v =>
      v.withIbewVote.toLowerCase().includes('absent')
    );

    const hasExcused = this.scorecard.votingHistory.some(v =>
      v.withIbewVote.toLowerCase().includes('excused')
    );

    if (hasExcused) {
      this.specialMessage =
        '**Excused absences are based on matters of public record or communications with the IBEW Government Affairs staff.';
    } else if (hasAbsent) {
      this.specialMessage =
        '*Reasons for absence are unknown to the IBEW. Please take this into consideration when evaluating your member of Congress.';
    }
  }

  calculateScore(): number {
    const history = this.scorecard?.votingHistory;
    if (!history?.length) return 0;

    let positive = 0;
    let total = 0;

    for (const vote of history) {
      const value = vote.withIbewVote?.toLowerCase();
      if (!value) continue;

      if (value.includes('with') || value.includes('against') || value.includes('absent')) 
      {
        total++;
        if (value.includes('with')) positive++;
      }
    }

    if (total === 0) return 0;

    return Math.round((positive / total) * 100);
  }

  updateScore(): void {
    this.score = this.calculateScore();
    this.scoreClass = this.score > 75 ? 'with' : 'against';
  }
}